import { Modal } from "antd";
import { useState, useEffect } from "react";
import { menuMap } from "./config";
import { CommonTablePage } from "./CommonTable";
import { CommonDetail } from "./CommonDetail";

export const CommonModal: React.FC<{
  type: string;
  visible: boolean;
  setVisible: (val: boolean) => void;
  param?: object;
  title?: string;
  currentRecord?: any;
  goToDetail?: (record: any, type: string) => void;
}> = ({
  type,
  visible,
  setVisible,
  param,
  title,
  goToDetail,
  currentRecord,
}) => {
  const [open, setOpen] = useState(visible);
  const [setting, setSetting] = useState(menuMap[type]);
  const [record, setRecord] = useState<any>(currentRecord);
  useEffect(() => {
    setOpen(visible);
    setSwitchDetail(null);
    setRecord(currentRecord);
  }, [visible]);
  const setSwitchDetail = (data: any) => {
    setRecord(data);
    goToDetail?.(data, type);
  };
  useEffect(() => {
    if (type) {
      setSetting({
        ...menuMap[type],
      });
    }
  }, [type]);
  // const bgColor = !record ? "rgba(1, 104, 126, 0.9)" : "transparent";
  const bgColor = !record ? "showBgColor" : "transparent";
  return (
    <Modal
      className={`commonModal ${bgColor}`}
      // bodyStyle={{ border: "10px solid red" }}
      // style={{
      //   backgroundColor: bgColor,
      // }}
      open={open}
      width={1545}
      onCancel={() => {
        setOpen(false);
        setVisible?.(false);
      }}
    >
      {setting && (
        <div className="dialog-item dialog-item1">
          {!record && (
            <div className="dialog-title">{title || setting?.title}</div>
          )}
          {record && (
            <CommonDetail
              details={setting.panels({
                ...param,
                data: record,
              })}
              type={type}
              record={record}
            />
          )}
          {!record && setting.table && (
            <CommonTablePage
              type={type}
              param={{
                ...param,
                setSwitchDetail,
              }}
            />
          )}
        </div>
      )}
    </Modal>
  );
};
